import {
  ChangeRequest,
  isValidChangeRequest,
  ValidChangeRequest,
} from 'Agent/Policies/models/ServiceRequest/ChangeRequest';
import {ValidInitialPolicyServiceRequest} from 'Agent/Policies/models/ServiceRequest/InitialPolicyServiceRequest';
import {PolicyServiceRequest} from 'Agent/Policies/models/ServiceRequest/PolicyServiceRequest';

export enum PremiumMode {
  Annual = 0,
  Semiannual = 1,
  PreauthorizedCheckPlan = 2,
  Quarterly = 3,
}

export class InvalidServiceRequestWithChange {
  public readonly key = 'InvalidPolicyServiceRequestWithChangeRequest';

  constructor(
    public readonly initialPolicyServiceRequestInformation: ValidInitialPolicyServiceRequest,
    public readonly changeRequest: ChangeRequest
  ) {}
}

export class ValidServiceRequestWithChange {
  public static create(
    initialPolicyServiceRequestInformation: ValidInitialPolicyServiceRequest,
    changeRequest: ChangeRequest
  ) {
    return isValidChangeRequest(changeRequest)
      ? new ValidServiceRequestWithChange(initialPolicyServiceRequestInformation, changeRequest)
      : new InvalidServiceRequestWithChange(initialPolicyServiceRequestInformation, changeRequest);
  }

  public readonly key = 'ValidPolicyServiceRequest';

  private constructor(
    public readonly initialPolicyServiceRequestInformation: ValidInitialPolicyServiceRequest,
    public readonly changeRequest: ValidChangeRequest
  ) {}
}

export const isValidPolicyServiceRequest = (
  serviceRequest: PolicyServiceRequest
): serviceRequest is ValidServiceRequestWithChange => serviceRequest.key === 'ValidPolicyServiceRequest';

export type PolicyServiceRequestWithChangeRequest = ValidServiceRequestWithChange | InvalidServiceRequestWithChange;
